<template>
  <div class="toggler">
    <ul class="toggler__toggler-list">
      <li
        class="toggler-list__toggler-item"
        :class="{active: !isPellets}"
        :disabled="!isPellets">
        <a :href="factoryURL" class="toggler-item__toggler-link">Softwood</a>
      </li>
      <li
        class="toggler-list__toggler-item"
        :class="{active: isPellets}"
        :disabled="isPellets">
        <a :href="pelletsURL" class="toggler-item__toggler-link">Pellets</a>
      </li>
    </ul>
  </div>
</template>

<script>
  import {FACTORY_NAME, PELLETS_URL, FACTORY_URL} from "@/config/config";
  export default {
    name: "FactoryTorggler",
    data() {
      return {
        factoryName: FACTORY_NAME ? FACTORY_NAME : ''
      }
    },
    computed: {
      isPellets() {
        return this.factoryName.toLowerCase() === 'pellets';
      },
      factoryURL() {
        return FACTORY_URL ? FACTORY_URL : '/';
      },
      pelletsURL() {
        return PELLETS_URL ? PELLETS_URL: '/';
      }
    }
  }
</script>

<style scoped lang="scss">
  .toggler {
    background-color: #417690;
    border-radius: 16px;
    padding: 3px;
    width: 150px;
    height: 29px;
  }

  .toggler__toggler-list {
    display: flex;
    list-style: none;
    justify-content: space-between;
    margin: 0;
    padding: 0;
  }

  .toggler-list__toggler-item {
    border-radius: 16px;
    padding: 1px 0;
    width: 50%;
    transition: .3s;
    text-align: center;
    cursor: pointer;
    &.active {
      background-color: rgba(#79AEC8, 1);
    }
    &:not(.active){
      &:hover, &:active {
        background-color: rgba(#79AEC8, .5);
      }

    }
  }

  .toggler-item__toggler-link {
    color: #ffffff;
    text-decoration: none;
    text-transform: capitalize;
    font-size: .8125rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/FactoryToggler.vue